export default __webpack_public_path__ + "static/media/image-jussi.423bed4b.png";